



















import { computed, defineComponent, ref } from "@vue/composition-api";
import TipController from "@/components/TipController";
import PostTippingModal from "./components/PostTippingModal.vue";

export default defineComponent({
  name: "PostTipping",
  components: { TipController, PostTippingModal },
  props: {
    feedId: { type: String, required: true },
  },
  setup(props) {
    const linkSubject = computed(() => {
      return { subjectId: props.feedId, subjectType: "content_set" };
    });

    const success = ref(false);

    const setSuccess = () => {
      success.value = true;
    };
    return {
      linkSubject,
      success,
      setSuccess,
    };
  },
});
